"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var vuex_1 = require("vuex");
var axios_1 = require("axios");
var $ = require("jquery");
var store_1 = require("../../../../../../resources/js/store/store");
var NotificationsList = /** @class */ (function (_super) {
    __extends(NotificationsList, _super);
    function NotificationsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notifications = [];
        _this.selectedNotifications = [];
        _this.isAllChecked = false;
        return _this;
    }
    Object.defineProperty(NotificationsList.prototype, "readyForDeletion", {
        get: function () {
            return !!this.selectedNotifications.length;
        },
        enumerable: false,
        configurable: true
    });
    NotificationsList.prototype.selectNotification = function () {
        $("#selectAll").prop('checked', false);
        this.isAllChecked = false;
    };
    NotificationsList.prototype.selectAll = function () {
        this.isAllChecked = !this.isAllChecked;
        this.selectedNotifications = [];
        if (this.isAllChecked) {
            for (var i = 0; i < this.notifications.length; i++) {
                this.selectedNotifications.push(this.notifications[i]);
            }
        }
    };
    NotificationsList.prototype.destroy = function () {
        var _this = this;
        if (this.readyForDeletion) {
            var _loop_1 = function (i) {
                if (this_1.selectedNotifications.length === this_1.notifications.length) {
                    this_1.selectNotification();
                }
                var index = this_1.notifications.findIndex(function (el) { return el.id === _this.selectedNotifications[i].id; });
                this_1.notifications.splice(index, 1);
                console.log(this_1.selectedNotifications);
                axios_1.default.delete('/settings', this_1.selectedNotifications)
                    .then(function (response) {
                    console.log(response);
                })
                    .catch(function (error) {
                    console.log(error);
                });
                store_1.default.dispatch('ACT_NOTIFICATIONS_LIST', this_1.notifications);
            };
            var this_1 = this;
            for (var i = 0; i < this.selectedNotifications.length; i++) {
                _loop_1(i);
            }
            this.selectedNotifications = [];
        }
    };
    ;
    NotificationsList.prototype.showMore = function () {
        var _this = this;
        if (this.notifications.links.next) {
            $(".loader").show();
            axios_1.default.get(this.notifications.links.next)
                .then(function (response) {
                var new_notifications = response.data;
                var old_list = store_1.default.state.list.data;
                var new_list = response.data.data;
                new_notifications.data = old_list.concat(new_list);
                _this.notifications = new_notifications;
                store_1.default.dispatch('ACT_NOTIFICATIONS_LIST', new_notifications);
                $(".loader").hide();
            })
                .catch(function (error) {
                console.log(error);
                $('.loader').hide();
            });
        }
    };
    NotificationsList.prototype.setImage = function (image) {
        return "background-image: url(/".concat(image, ")");
    };
    NotificationsList.prototype.formatDate = function (date) {
        var YESTERDAY = 2880;
        var TODAY = 1440;
        var HOURS = 720;
        var HOUR = 60;
        var CURRENT_TIME = new Date().getTime();
        var NOTIFICATION_TIME = new Date(date).getTime();
        var DIFFERENCE_IN_MINUTES = (CURRENT_TIME - NOTIFICATION_TIME) / 1000 / 60;
        var FORMATTED_MINUTES = DIFFERENCE_IN_MINUTES.toFixed();
        var YEAR = new Date(date).getFullYear();
        var MONTH = new Date(date).getMonth();
        var DAY = new Date(date).getDate();
        if (FORMATTED_MINUTES > YESTERDAY) {
            return "".concat(DAY, ".").concat(MONTH, ".").concat(YEAR);
        }
        else if (FORMATTED_MINUTES > TODAY && FORMATTED_MINUTES <= YESTERDAY) {
            return "Yesterday";
        }
        else if (FORMATTED_MINUTES > HOURS && FORMATTED_MINUTES <= TODAY) {
            return "Today";
        }
        else if (FORMATTED_MINUTES > HOUR && FORMATTED_MINUTES <= HOURS) {
            return "".concat((FORMATTED_MINUTES / 60).toFixed(), " h ago");
        }
        else {
            return "".concat(FORMATTED_MINUTES, " min ago");
        }
    };
    NotificationsList = __decorate([
        (0, vue_property_decorator_1.Component)({
            computed: (0, vuex_1.mapGetters)(['GET_NOTIFICATIONS_LIST', 'GET_NOTIFICATIONS_COUNT']),
            mounted: function () {
                var list = this.GET_NOTIFICATIONS_LIST.map(function (el) { return (__assign({}, el)); });
                this.notifications = list;
            }
        })
    ], NotificationsList);
    return NotificationsList;
}(vue_property_decorator_1.Vue));
exports.default = NotificationsList;
